import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getPopulationTrends() {
  try {
    const resp = await axios.get("/api/populationtrend/?pageSize=30");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createPopulationTrend(populationtrend: object) {
  try {
    const resp = await axios.put(
      "/api/populationtrend/create/",
      populationtrend
    );
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updatePopulationTrend(populationtrend: object) {
  try {
    const resp = await axios.post(
      "/api/populationtrend/update/",
      populationtrend
    );
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function deleteTrend(trend_id: string) {
  try {
    const resp = await axios.delete(
      "/api/populationtrend/delete?id=" + trend_id
    );
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
